import { FC } from 'react'
import { StyledBurger, StyledBurgerText, StyledBurgerWrapper } from './Burger.style'

export interface IBurger {
  open?: boolean
  setOpen?: (arg: boolean) => void
  text?: string
}

const Burger: FC<IBurger> = ({ open, setOpen, text }) => {
  return (
    <StyledBurgerWrapper>
      {text && (
        <StyledBurgerText open={open} onClick={() => setOpen?.(!open)}>
          {text}
        </StyledBurgerText>
      )}
      <div>
        <StyledBurger open={open} onClick={() => setOpen?.(!open)}>
          <div />
          <div />
          <div />
        </StyledBurger>
      </div>
    </StyledBurgerWrapper>
  )
}

export default Burger
